var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgStorage = function SvgStorage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#storage_svg__a)",
    rx: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 24h20v-4H6zm2-3h2v2H8zM6 8v4h20V8zm4 3H8V9h2zm-4 7h20v-4H6zm2-3h2v2H8z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "storage_svg__a",
    x1: 3,
    x2: 36,
    y1: 30,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F2E55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4277FC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgStorage);
export default ForwardRef;